var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "10px" } },
        [
          _c("div", { staticClass: "filter-bar" }, [
            _c(
              "div",
              { staticClass: "filter-item" },
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("trajectory.Time"))),
                ]),
                _c("el-date-picker", {
                  staticStyle: { width: "200px" },
                  attrs: {
                    placeholder: _vm.$t("operationCenter.SelectDate"),
                    size: "small",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                  },
                  model: {
                    value: _vm.queryParams.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "date", $$v)
                    },
                    expression: "queryParams.date",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "filter-item" },
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("routes.equipmentTitle"))),
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: _vm.$t("dictionary.pleaseChoose"),
                      filterable: "",
                      size: "small",
                    },
                    on: { change: _vm.handleDeviceChange },
                    model: {
                      value: _vm.queryParams.machineId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "machineId", $$v)
                      },
                      expression: "queryParams.machineId",
                    },
                  },
                  _vm._l(_vm.machineList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.machineName, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "filter-item" },
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("newOperationCenter.rule"))),
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "200px" },
                    attrs: {
                      placeholder: _vm.$t("dictionary.pleaseChoose"),
                      clearable: "",
                      filterable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.queryParams.ruleId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "ruleId", $$v)
                      },
                      expression: "queryParams.ruleId",
                    },
                  },
                  _vm._l(_vm.ruleList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.ruleName, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "filter-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-search",
                      size: "small",
                      type: "success",
                    },
                    on: { click: _vm.searchBtn },
                  },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.search")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-refresh",
                      plain: "",
                      size: "small",
                      type: "success",
                    },
                    on: { click: _vm.handleReset },
                  },
                  [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")) + " ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "10px" } },
        [
          _c("div", { staticClass: "stat-cards" }, [
            _c("div", { staticClass: "stat-card" }, [
              _c("div", { staticClass: "stat-info" }, [
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("CenterForSorting.totalChutes"))),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.totalChuteCount || "--")),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("newOperationCenter.usedCompartment"))
                    ),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.userChuteCount || "--")),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("newOperationCenter.emptyCompartment"))
                    ),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.unUserChuteCount || "--")),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "stat-chart" },
                [
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.kanbanBoard.utilizationRateNum,
                      width: 100,
                      color: "#13ce66",
                      type: "circle",
                    },
                  }),
                  _c("div", { staticClass: "chart-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("newOperationCenter.utilizationRate"))
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "stat-card" }, [
              _c("div", { staticClass: "stat-info" }, [
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("newOperationCenter.normalCompartmentCount")
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.normalChuteCount)),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("newOperationCenter.abnormalCompartmentCount")
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.abnormalChuteCount)),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "stat-card" }, [
              _c("div", { staticClass: "stat-info" }, [
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("newOperationCenter.normalBagDropCount"))
                    ),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.normalPackageRate)),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("newOperationCenter.abnormalBagDropCount"))
                    ),
                  ]),
                  _c("span", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.kanbanBoard.abnormalPackageRate)),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _c(
            "div",
            { staticClass: "section-header" },
            [
              _c("div", { staticClass: "title" }, [
                _c("i", { staticClass: "el-icon-s-grid green-icon" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("newOperationCenter.normalSortingVolumeStats")
                    ) +
                    " "
                ),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "expand-all-btn",
                  attrs: { size: "mini", type: "text" },
                  on: { click: _vm.toggleExpandAll },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isTableExpanded
                          ? _vm.$t("newOperationCenter.collapseAll")
                          : _vm.$t("newOperationCenter.expandAll")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "normalTable",
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                data: _vm.normalTableData,
                "tree-props": { children: "detailDataList" },
                border: "",
                "row-key": "id",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("CenterForSorting.sortingRuleName") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(" " + _vm._s(row.ruleName) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.chuteNum"),
                  align: "center",
                  prop: "chuteData",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        typeof scope.row.chuteData === "number"
                          ? _c("div", [
                              _vm._v(" " + _vm._s(scope.row.chuteData) + " "),
                            ])
                          : _vm._e(),
                        typeof scope.row.chuteData === "string"
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "primary" } },
                              [_vm._v(" " + _vm._s(scope.row.chuteData) + " ")]
                            )
                          : _c("div"),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOperationCenter.preDeliveryHubCount"),
                  align: "center",
                  prop: "preDeliverySiteData",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("trajectory.NumberPackages"),
                  align: "center",
                  prop: "packageCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOperationCenter.normalBagDropRatio"),
                  align: "center",
                  prop: "countRate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-section", staticStyle: { "margin-top": "10px" } },
        [
          _c("div", { staticClass: "section-header" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", { staticClass: "el-icon-document green-icon" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("newOperationCenter.abnormalSortingVolumeStats")
                  ) +
                  " "
              ),
            ]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.errorTableData,
                border: "",
                "header-cell-class-name": "table-header-gray",
                stripe: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.sortingRuleName"),
                  align: "center",
                  prop: "ruleName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.chuteNo"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "primary" } },
                          [_vm._v(_vm._s(scope.row.chuteNumber))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOperationCenter.NumberPackages"),
                  align: "center",
                  prop: "packageCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOperationCenter.abnormalBagDropRatio"),
                  align: "center",
                  prop: "countRate",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }